import {Fragment, useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Table, {atomTableCellPadding} from '@s-ui/react-atom-table'
import Context from '@s-ui/react-context'
import MoleculeAccordion, {moleculeAccordionBehavior, MoleculeAccordionItem} from '@s-ui/react-molecule-accordion'
import IconAccordionCollapsed from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconAccordionExpanded from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS, SECTION_LABEL_MAP} from './settings.js'

export const AccordionView = ({equipment, section}) => {
  const {i18n} = useContext(Context)
  const getTableBody = descriptions => {
    return descriptions.map(({value}) => {
      return [
        {
          content: <span className={`${BASE_CLASS}-tableItem`}>{value}</span>,
          isNowrap: false
        }
      ]
    })
  }
  return Object.keys(equipment).map((section, i) => {
    const hasSectionData = Boolean(equipment[section])
    const sectionTitle = i18n.t(SECTION_LABEL_MAP[section])
    return (
      hasSectionData && (
        <>
          <div className={`${BASE_CLASS}-title`}>
            <TitleBasic as={titleBasicTags.h2} title={sectionTitle} size={titleBasicSizes.s} />
          </div>
          {equipment[section]?.map(({title, descriptions}, i) => {
            return (
              <MoleculeAccordion
                as={Fragment}
                behavior={moleculeAccordionBehavior.MULTIPLE}
                headerIconCollapsed={<IconAccordionCollapsed size={ATOM_ICON_SIZES.medium} />}
                headerIconExpanded={<IconAccordionExpanded size={ATOM_ICON_SIZES.medium} />}
              >
                <div className={`${BASE_CLASS}-accordion`}>
                  <MoleculeAccordionItem as="div" headerAs="h3" label={title}>
                    <div className={`${BASE_CLASS}-table`}>
                      <Table
                        body={getTableBody(descriptions)}
                        fullWidth
                        cellPadding={atomTableCellPadding.l}
                        zebraStriped
                      />
                    </div>
                  </MoleculeAccordionItem>
                </div>
              </MoleculeAccordion>
            )
          })}
        </>
      )
    )
  })
}

AccordionView.propTypes = {
  equipment: PropTypes.array,
  section: PropTypes.string
}
